// extracted by mini-css-extract-plugin
export default {"fontSize":"ChooseRequestedStampsRow_fontSize__O+xy1","title":"ChooseRequestedStampsRow_title__BrezN"};